/**
 * HSVからRGB値に変換。
 * @param h 色相 0~360
 * @param s 彩度 0~1
 * @param v 明度 0~1
 * @returns r, g, b 配列 0~1.0
 */
export function hsvToRgbValues255(h: number, s: number, v: number): number[] {
  var c = v * s;
  var hp = h / 60;
  var x = c * (1 - Math.abs((hp % 2) - 1));

  var r, g, b;
  if (0 <= hp && hp < 1) {
    [r, g, b] = [c, x, 0];
  }
  if (1 <= hp && hp < 2) {
    [r, g, b] = [x, c, 0];
  }
  if (2 <= hp && hp < 3) {
    [r, g, b] = [0, c, x];
  }
  if (3 <= hp && hp < 4) {
    [r, g, b] = [0, x, c];
  }
  if (4 <= hp && hp < 5) {
    [r, g, b] = [x, 0, c];
  }
  if (5 <= hp && hp < 6) {
    [r, g, b] = [c, 0, x];
  }

  var m = v - c;
  [r, g, b] = [r + m, g + m, b + m];

  r = Math.floor(r * 255);
  g = Math.floor(g * 255);
  b = Math.floor(b * 255);

  return [r, g, b];
}

/**
 * HSVAからカラーコードに変換。
 * @param h 色相 0~360
 * @param s 彩度 0~1
 * @param v 明度 0~1
 * @param a 不透明度 0~1
 * @returns 16進数カラーコード
 */
export function hsvToHexColorCode(
  h: number,
  s: number,
  v: number,
  a: number = 1,
): string {
  const rgb_values = hsvToRgbValues255(h, s, v);
  return (
    '#' +
    toHex(rgb_values[0]) +
    toHex(rgb_values[1]) +
    toHex(rgb_values[2]) +
    toHex(a * 255)
  );
}

/**
 * 16進文字列に変換して0埋め。
 * @param value
 * @returns
 */
function toHex(value: number) {
  return value.toString(16).padStart(2, '0');
}

/**
 * valueを最小値と最大値のどの位置にあるか比率を返す。
 * @param value
 * @param min
 * @param max
 * @returns
 */
function calcRatio(value: number, min: number, max: number): number {
  // エラーチェック
  if (max <= min) {
    console.error(`max(${max}) < min(${min})`);
    return undefined;
  }

  let fix_value: number;
  if (value < min) fix_value = 0;
  else if (value > max) fix_value = max;
  else fix_value = value - min;

  const range = max - min;
  return fix_value / range;
}

/**
 * value を min, max間の比率に置き換えて、newMin, newMax に間に再配置する。
 * @param value
 * @param min
 * @param max
 * @param newMin
 * @param newMax
 * @returns
 */
export function calcRelocation(
  value: number,
  min: number,
  max: number,
  newMin: number,
  newMax: number,
) {
  const ratio = calcRatio(value, min, max);
  let new_range = newMax - newMin;
  return newMin + ratio * new_range;
}
